'use strict';

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Clone = require('@hapi/hoek/lib/clone');
var Common = require('./common');
var Messages = require('./messages');
var Ref = require('./ref');
var Template = require('./template');
var Schemas;
var internals = {};
exports.describe = function (schema) {
  var def = schema._definition;

  // Type

  var desc = {
    type: schema.type,
    flags: {},
    rules: []
  };

  // Flags

  for (var flag in schema._flags) {
    if (flag[0] !== '_') {
      desc.flags[flag] = internals.describe(schema._flags[flag]);
    }
  }
  if (!Object.keys(desc.flags).length) {
    delete desc.flags;
  }

  // Preferences

  if (schema._preferences) {
    desc.preferences = Clone(schema._preferences, {
      shallow: ['messages']
    });
    delete desc.preferences[Common.symbols.prefs];
    if (desc.preferences.messages) {
      desc.preferences.messages = Messages.decompile(desc.preferences.messages);
    }
  }

  // Allow / Invalid

  if (schema._valids) {
    desc.allow = schema._valids.describe();
  }
  if (schema._invalids) {
    desc.invalid = schema._invalids.describe();
  }

  // Rules
  var _iterator = _createForOfIteratorHelper(schema._rules),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rule = _step.value;
      var ruleDef = def.rules[rule.name];
      if (ruleDef.manifest === false) {
        // Defaults to true
        continue;
      }
      var _item2 = {
        name: rule.name
      };
      for (var custom in def.modifiers) {
        if (rule[custom] !== undefined) {
          _item2[custom] = internals.describe(rule[custom]);
        }
      }
      if (rule.args) {
        _item2.args = {};
        for (var key in rule.args) {
          var arg = rule.args[key];
          if (key === 'options' && !Object.keys(arg).length) {
            continue;
          }
          _item2.args[key] = internals.describe(arg, {
            assign: key
          });
        }
        if (!Object.keys(_item2.args).length) {
          delete _item2.args;
        }
      }
      desc.rules.push(_item2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!desc.rules.length) {
    delete desc.rules;
  }

  // Terms (must be last to verify no name conflicts)

  for (var term in schema.$_terms) {
    if (term[0] === '_') {
      continue;
    }
    Assert(!desc[term], 'Cannot describe schema due to internal name conflict with', term);
    var items = schema.$_terms[term];
    if (!items) {
      continue;
    }
    if (items instanceof Map) {
      if (items.size) {
        desc[term] = _toConsumableArray(items.entries());
      }
      continue;
    }
    if (Common.isValues(items)) {
      desc[term] = items.describe();
      continue;
    }
    Assert(def.terms[term], 'Term', term, 'missing configuration');
    var manifest = def.terms[term].manifest;
    var mapped = typeof manifest === 'object';
    if (!items.length && !mapped) {
      continue;
    }
    var normalized = [];
    var _iterator2 = _createForOfIteratorHelper(items),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _item = _step2.value;
        normalized.push(internals.describe(_item));
      }

      // Mapped
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if (mapped) {
      var _manifest$mapped = manifest.mapped,
        from = _manifest$mapped.from,
        to = _manifest$mapped.to;
      desc[term] = {};
      var _iterator3 = _createForOfIteratorHelper(normalized),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          desc[term][item[to]] = item[from];
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      continue;
    }

    // Single

    if (manifest === 'single') {
      Assert(normalized.length === 1, 'Term', term, 'contains more than one item');
      desc[term] = normalized[0];
      continue;
    }

    // Array

    desc[term] = normalized;
  }
  internals.validate(schema.$_root, desc);
  return desc;
};
internals.describe = function (item) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Array.isArray(item)) {
    return item.map(internals.describe);
  }
  if (item === Common.symbols.deepDefault) {
    return {
      special: 'deep'
    };
  }
  if (typeof item !== 'object' || item === null) {
    return item;
  }
  if (options.assign === 'options') {
    return Clone(item);
  }
  if (Buffer && Buffer.isBuffer(item)) {
    // $lab:coverage:ignore$
    return {
      buffer: item.toString('binary')
    };
  }
  if (item instanceof Date) {
    return item.toISOString();
  }
  if (item instanceof Error) {
    return item;
  }
  if (item instanceof RegExp) {
    if (options.assign === 'regex') {
      return item.toString();
    }
    return {
      regex: item.toString()
    };
  }
  if (item[Common.symbols.literal]) {
    return {
      function: item.literal
    };
  }
  if (typeof item.describe === 'function') {
    if (options.assign === 'ref') {
      return item.describe().ref;
    }
    return item.describe();
  }
  var normalized = {};
  for (var key in item) {
    var value = item[key];
    if (value === undefined) {
      continue;
    }
    normalized[key] = internals.describe(value, {
      assign: key
    });
  }
  return normalized;
};
exports.build = function (joi, desc) {
  var builder = new internals.Builder(joi);
  return builder.parse(desc);
};
internals.Builder = /*#__PURE__*/function () {
  function _class(joi) {
    _classCallCheck(this, _class);
    this.joi = joi;
  }
  _createClass(_class, [{
    key: "parse",
    value: function parse(desc) {
      var _this = this;
      internals.validate(this.joi, desc);

      // Type

      var schema = this.joi[desc.type]();
      var def = schema._definition;

      // Flags

      if (desc.flags) {
        for (var flag in desc.flags) {
          var setter = def.flags[flag] && def.flags[flag].setter || flag;
          Assert(typeof schema[setter] === 'function', 'Invalid flag', flag, 'for type', desc.type);
          schema = schema[setter](this.build(desc.flags[flag]));
        }
      }

      // Preferences

      if (desc.preferences) {
        schema = schema.preferences(this.build(desc.preferences));
      }

      // Allow / Invalid

      if (desc.allow) {
        var _schema;
        schema = (_schema = schema).allow.apply(_schema, _toConsumableArray(this.build(desc.allow)));
      }
      if (desc.invalid) {
        var _schema2;
        schema = (_schema2 = schema).invalid.apply(_schema2, _toConsumableArray(this.build(desc.invalid)));
      }

      // Rules

      if (desc.rules) {
        var _iterator4 = _createForOfIteratorHelper(desc.rules),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _schema3;
            var rule = _step4.value;
            Assert(typeof schema[rule.name] === 'function', 'Invalid rule', rule.name, 'for type', desc.type);
            var args = [];
            if (rule.args) {
              var built = {};
              for (var key in rule.args) {
                built[key] = this.build(rule.args[key], {
                  assign: key
                });
              }
              var keys = Object.keys(built);
              var definition = def.rules[rule.name].args;
              if (definition) {
                Assert(keys.length <= definition.length, 'Invalid number of arguments for', desc.type, rule.name, '(expected up to', definition.length, ', found', keys.length, ')');
                var _iterator5 = _createForOfIteratorHelper(definition),
                  _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var name = _step5.value.name;
                    args.push(built[name]);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
              } else {
                Assert(keys.length === 1, 'Invalid number of arguments for', desc.type, rule.name, '(expected up to 1, found', keys.length, ')');
                args.push(built[keys[0]]);
              }
            }

            // Apply

            schema = (_schema3 = schema)[rule.name].apply(_schema3, args);

            // Ruleset

            var options = {};
            for (var custom in def.modifiers) {
              if (rule[custom] !== undefined) {
                options[custom] = this.build(rule[custom]);
              }
            }
            if (Object.keys(options).length) {
              schema = schema.rule(options);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      // Terms

      var terms = {};
      for (var _key in desc) {
        if (['allow', 'flags', 'invalid', 'whens', 'preferences', 'rules', 'type'].includes(_key)) {
          continue;
        }
        Assert(def.terms[_key], 'Term', _key, 'missing configuration');
        var manifest = def.terms[_key].manifest;
        if (manifest === 'schema') {
          terms[_key] = desc[_key].map(function (item) {
            return _this.parse(item);
          });
          continue;
        }
        if (manifest === 'values') {
          terms[_key] = desc[_key].map(function (item) {
            return _this.build(item);
          });
          continue;
        }
        if (manifest === 'single') {
          terms[_key] = this.build(desc[_key]);
          continue;
        }
        if (typeof manifest === 'object') {
          terms[_key] = {};
          for (var _name in desc[_key]) {
            var value = desc[_key][_name];
            terms[_key][_name] = this.parse(value);
          }
          continue;
        }
        terms[_key] = this.build(desc[_key]);
      }
      if (desc.whens) {
        terms.whens = desc.whens.map(function (when) {
          return _this.build(when);
        });
      }
      schema = def.manifest.build(schema, terms);
      schema.$_temp.ruleset = false;
      return schema;
    }
  }, {
    key: "build",
    value: function build(desc) {
      var _this2 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (desc === null) {
        return null;
      }
      if (Array.isArray(desc)) {
        return desc.map(function (item) {
          return _this2.build(item);
        });
      }
      if (desc instanceof Error) {
        return desc;
      }
      if (options.assign === 'options') {
        return Clone(desc);
      }
      if (options.assign === 'regex') {
        return internals.regex(desc);
      }
      if (options.assign === 'ref') {
        return Ref.build(desc);
      }
      if (typeof desc !== 'object') {
        return desc;
      }
      if (Object.keys(desc).length === 1) {
        if (desc.buffer) {
          Assert(Buffer, 'Buffers are not supported');
          return Buffer && Buffer.from(desc.buffer, 'binary'); // $lab:coverage:ignore$
        }
        if (desc.function) {
          return _defineProperty(_defineProperty({}, Common.symbols.literal, true), "literal", desc.function);
        }
        if (desc.override) {
          return Common.symbols.override;
        }
        if (desc.ref) {
          return Ref.build(desc.ref);
        }
        if (desc.regex) {
          return internals.regex(desc.regex);
        }
        if (desc.special) {
          Assert(['deep'].includes(desc.special), 'Unknown special value', desc.special);
          return Common.symbols.deepDefault;
        }
        if (desc.value) {
          return Clone(desc.value);
        }
      }
      if (desc.type) {
        return this.parse(desc);
      }
      if (desc.template) {
        return Template.build(desc);
      }
      var normalized = {};
      for (var key in desc) {
        normalized[key] = this.build(desc[key], {
          assign: key
        });
      }
      return normalized;
    }
  }]);
  return _class;
}();
internals.regex = function (string) {
  var end = string.lastIndexOf('/');
  var exp = string.slice(1, end);
  var flags = string.slice(end + 1);
  return new RegExp(exp, flags);
};
internals.validate = function (joi, desc) {
  Schemas = Schemas || require('./schemas');
  joi.assert(desc, Schemas.description);
};